import { useCallback } from 'react';
import { FieldArray, useFormikContext } from 'formik';
import Spacer from '@antimatterhq/ui/components/spacer';
import { Button } from '@antimatterhq/ui/components/button';
import { PreTransformSchemaFormValues } from '@/zod/schemas/dataSource/PreTransform';
import { StreamTable } from '@/components/streamTable/StreamTable';
import { StreamTableSchemaValues } from '@/zod/schemas/StreamTableSchema';

export const PreTransformAdditionalBronzeTables = () => {
  const { values } = useFormikContext<PreTransformSchemaFormValues>();

  const createBronzeTable = useCallback(() => {
    const bronzeTable: StreamTableSchemaValues = {
      name: '',
      streaming: false,
      watermark: {
        eventTimeColumn: 'time',
        delayThreshold: '',
        dropDuplicates: [],
      },
      alias: '',
      joinType: '',
      joinExpr: '',
      aliasRequired: true,
      joinHidden: false,
    };

    return bronzeTable;
  }, []);

  return (
    <div>
      <FieldArray name="bronzeTables">
        {({ remove, push }) => (
          <>
            {values.bronzeTables.map((bronzeTable, index) => (
              <div key={`bronzeTable-${index}`}>
                <Spacer size="lg" />
                <StreamTable
                  index={index}
                  table={bronzeTable}
                  remove={remove}
                  prefix="bronzeTables"
                  enableDatabricksTableValidation
                  tableSchema={'bronzeSchema'}
                />
              </div>
            ))}

            <Spacer size="lg" />

            <Button
              variant="default"
              data-testid="pre-transform-add-bronze-table-button"
              onClick={() => push(createBronzeTable())}
            >
              Join an additional bronze table
            </Button>
          </>
        )}
      </FieldArray>
    </div>
  );
};
